module.exports = __webpack_public_path__ + "static/media/dev-lab.9bd455b8.webp";